import axios from 'axios';
import {url} from "@/assets/js/config";
import Vue from 'vue';
import store from '../../vue/vuex/store'
import router from '@/vue/router/';

let instance = axios.create({
    timeout: 60000,
    baseURL: process.env.NODE_ENV === "development" ? "" : "",
    withCredentials: true // 允许携带cookie
});
// Toast.allowMultiple();
instance.interceptors.request.use((config) => {
    if (config.method === 'post' || config.method === 'put') {
        config.headers["Content-Type"] = "application/json;";
        
        let sessionId = localStorage.getItem('sessionId');

        if(sessionId){
            config.headers["x-auth-token"] = sessionId
        }
        
        config.headers["channel"] = "app";
       
        config.data = JSON.stringify(config.data);
    }
    // if (!config.headers.Authorization) {
    //     config.headers.Authorization = 'Bearer ' + (window.localStorage.getItem('Authorization') || '');
    // }
    return config;
}, (err) => {
    return Promise.reject(err);
});

instance.interceptors.response.use((res) => {
    if (res.data.code != 0) {
        if (res.data.code == 700) { //当前用户未登录

            if (window.location.href.search("window") != "-1") {
                return;
            }

            Vue.prototype.$message.error("登录已过期 请重新登录!");

            setTimeout(() => {
                router.replace('/login')
            }, 1000);
        } else {
            // 设置了hiddenError的不提示
            if((!res.config.hiddenError) && res && res.data && res.data.errorMessage){
                Vue.prototype.$message.error(res.data.errorMessage);
            }
        }
        return Promise.reject(res);
    }
    return res;
}, (error) => {
    if (error.message.indexOf('timeout of') >= 0 ) {
        Vue.prototype.$message.error("请求超时！");
        return Promise.reject(error);
    }
    // Vue.prototype.$message.error("请求出现错误！");
    return Promise.reject(error);
});

const post = (reqUrl, data, config = {},authToken) => {
    reqUrl = url().baseUrl +  reqUrl

    // let appId = store.state.appId
    // data.appId = appId

    return instance.post(reqUrl, data, config , authToken)
}

const put = (url, data, config = {}) => {
    return instance.put(url, data, config)
}

const get = (url, params, config = {}) => {
    reqUrl = url().baseUrl +  reqUrl
    return instance.get(reqUrl, {
        params: params,
        ...config
    })
}

const deleteMethod = (url, config = {}) => {
    return instance({
        url: url,
        method: 'delete',
        ...config
    })
}

export default {
    install(Vue) {
        Object.defineProperties(Vue.prototype, {
            $reqGet: {
                value: get
            },
            $reqPost: {
                value: post
            },
            $reqPut: {
                value: put
            },
            $reqDel: {
                value: deleteMethod
            },
        })
    }
}


// WEBPACK FOOTER //
// ./src/vue/plugins/axios.js